﻿import { setCookie, getCookie } from '../utils/cookieUtils.js';
import { getUsageRatio } from '../utils/subscriptionUtils.js';
import { formatToPrecent } from '../utils/currencyUtils.js';
import { getCurrentDay } from '../utils/dateFormatUtils.js';
import moment from 'moment';

export class ConversionsModalsComponent {
    constructor(currentPlan) {
        const self = this;
        self.currentPlan = currentPlan;
        self.availableUploadsProgress = getUsageRatio(self.currentPlan.remainingConversions, self.currentPlan.conversions);
        self.MODAL_COOKIE_RESET_IN_DAYS = 7;
        
        self.MODAL_TYPES = {
            EXPIRED: 'expired',
            LIMIT: 'limit',
            ALMOST: 'almost',
            CONTACT: 'contact',
            ALMOST_CONTACT: 'almostContact'
        };

        self.LARGEST_PLAN_CODE = 'BSN';

        self.modals = {
            almost: {
                selector:'#subscriptionModalAlmost'
            },
            limit:{
                selector: '#subscriptionModalLimit'
            },
            contact:{
                selector: '#subscriptionModalContact'
            },
            expired:{
                selector: '#licenseModal'
            },
            almostContact:{
                selector: '#subscriptionModalAlmostContact'
            }
        }
    }

    async initialize() {
        return new Promise((resolve) => setTimeout(resolve, 100));
    }

    toggleModalVisibility(selector, state) {
        const stateFormModals = state ? 'show' : 'hide';
        const modal = $(selector).modal();
        if (modal) {
            $(selector).modal(stateFormModals);
            
        } else {
            console.error(`No modal with selector ${selector} is found!`);
        }
    }

    isSubscriptionExpired(currentPlan) {
        const currentDate = moment();
        const endDate = moment(currentPlan.endDate);
        return currentDate.isAfter(endDate);
    }

    getModal(modalType) {
        const self = this;
        const modals = self.modals;

        switch (modalType) {
            case "expired":
                return modals.expired;
            case "limit":
                return modals.limit;
            case "contact":
                return modals.contact;
            case "almost":
                return modals.almost;
            case "almostContact":
                return modals.almostContact;
            default:
                return null;
        };
    };

    determineModalType(plan, usageRatio, isLimit) {
        const self = this;

        const USAGE_ALMOST_VALUE = 0.8;
        const USAGE_LIMIT_VALUE = 1;
        if (self.isSubscriptionExpired(plan) && !getCookie('modalExpiredShown')) {
            setCookie('modalExpiredShown', 'true', self.MODAL_COOKIE_RESET_IN_DAYS);
            return self.MODAL_TYPES.EXPIRED;
        }

        if (plan.remainingConversions === 0 || isLimit) {
            
            if (self.currentPlan.planCode === self.LARGEST_PLAN_CODE) {
                return self.MODAL_TYPES.CONTACT;
            }
            return self.MODAL_TYPES.LIMIT;
        }

        if (usageRatio >= USAGE_ALMOST_VALUE && usageRatio < USAGE_LIMIT_VALUE && !getCookie('modalAlmostShown')) {
            setCookie('modalAlmostShown', 'true', self.MODAL_COOKIE_RESET_IN_DAYS);
            if (self.currentPlan.planCode === self.LARGEST_PLAN_CODE) {
                return self.MODAL_TYPES.ALMOST_CONTACT;
            }
            return self.MODAL_TYPES.ALMOST;
        }
        
        return null; // No modal to show
    }

    toggleModals(plan, isLimit) {
        const self = this;
        self.availableUploadsProgress = getUsageRatio(plan.remainingConversions, plan.conversions);
        const modalToShow = self.determineModalType(plan, self.availableUploadsProgress, isLimit);
        if (modalToShow !== null) {
            self.toggleModalVisibility(self.getModal(modalToShow).selector, true)
        };
        
    }
}